export default "__VITE_ASSET__Cv6bw1j9__"